<template>
  <div>
    <el-form class="common_form" label-width="120px" label-position="left">
      <el-row>
        <el-col :span="24">
          <el-form-item label="线索池">
            <el-checkbox-group v-model="formData.agendaPoolChoice">
              <el-checkbox v-for="item in functionLeadPool" :label="item.permissionId" :key="item.id" name="agendaPoolChoice"> {{ item.permissionName }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="私海池">
            <el-checkbox-group v-model="formData.agendaSeaChoice">
              <el-checkbox v-for="item in functionPrivateSea" :label="item.permissionId" :key="item.id" name="agendaPoolChoice"> {{ item.permissionName }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="系统设置">
            <el-checkbox-group v-model="formData.agendaConfigChoice">
              <el-checkbox v-for="item in functionSysConfig" :label="item.permissionId" :key="item.id" name="agendaPoolChoice"> {{ item.permissionName }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>

export default {
  data () {
    return {
      formData: {
        agendaPoolChoice: [],
        agendaConfigChoice: [],
        agendaSeaChoice: []
      },
      // 所有选择列表
      functionLeadPool: [],
      functionSysConfig: [],
      functionPrivateSea: []
    };
  },
  props: {
    functionlead: {
      type: Array,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: []
    },
    trastlist: {
      type: Array,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: []
    }
  },
  watch: {
    functionlead () {
      this.setData(this.functionlead);
    },
    trastlist () {
      let MissIdList = [];
      this.trastlist.forEach(item => {
        switch (item.optionType) {
          case 'lead_function_private_sea':
            MissIdList = item.sysPermissionList.map(val => { return val.permissionId; });
            this.$set(this.formData, 'agendaSeaChoice', MissIdList);
            break;
          case 'lead_function_sys_config':
            MissIdList = item.sysPermissionList.map(val => { return val.permissionId; });
            this.$set(this.formData, 'agendaConfigChoice', MissIdList);
            break;
          case 'lead_function_lead_pool':
            MissIdList = item.sysPermissionList.map(val => { return val.permissionId; });
            this.$set(this.formData, 'agendaPoolChoice', MissIdList);
            break;
        }
      });
    }
  },
  methods: {
    setData (functionData) {
      functionData.forEach(item => {
        switch (item.optionType) {
          case 'lead_function_private_sea':
            this.functionPrivateSea = item.sysPermissionList;
            break;
          case 'lead_function_sys_config':
            this.functionSysConfig = item.sysPermissionList;
            break;
          case 'lead_function_lead_pool':
            this.functionLeadPool = item.sysPermissionList;
            break;
        }
      });
    }
  },
  mounted () {
    this.setData(this.functionlead);
  }
};
</script>

<style scoped>
</style>
